const _raw = (e) => e?.detail?.value ?? e?.target?.value ?? e;

export const readSdxValue = (e) => {
  const raw = _raw(e);
  if (Array.isArray(raw)) return readSdxValue(raw[0]);
  if (raw && typeof raw === 'object') return raw.value ?? raw.label ?? '';
  return String(raw ?? '');
};

export const readSdxValueList = (e) => {
  const raw = _raw(e);
  const arr = Array.isArray(raw) ? raw : [raw];
  return arr
    .map((x) => (x && typeof x === 'object' ? (x.value ?? x.label ?? '') : String(x ?? '')))
    .filter((v) => v !== '');
};
